import { POSA_FORMAT } from "@tootsweet/model/lottery/POSAType";
import { tt } from "../../utils/i18n/i18n";

export const JETPACK_ONBOARDING_STEPS = {
  STEP_0_INFO: "STEP_0_INFO",
  STEP_1_GAMES: "STEP_1_GAMES",
  STEP_2_CTAs: "STEP_2_CTAs",
  STEP_3_GIFTS: "STEP_3_GIFTS",
  STEP_4_LAST_STEP: "STEP_4_LAST_STEP",
  STEP_5_ROCKET_ANIMATION: "STEP_5_ROCKET_ANIMATION"
};

export const CREATE_GIFTS_WORDING = tt(
  "jp_onboarding_title_step_gift_selector"
);
export const GENERATE_GIFT_WORDING = tt(
  "jp_onboarding_title_step_gift_selector_01"
);

export const TITLE = {
  [JETPACK_ONBOARDING_STEPS.STEP_0_INFO]: tt("jetpack_onboarding_step_1_title"),
  [JETPACK_ONBOARDING_STEPS.STEP_1_GAMES]: tt(
    "jetpack_onboarding_step_2_title"
  ),
  [JETPACK_ONBOARDING_STEPS.STEP_2_CTAs]: tt(
    "jp_onboarding_title_step_cta_selector"
  ),
  [JETPACK_ONBOARDING_STEPS.STEP_3_GIFTS]: CREATE_GIFTS_WORDING
};

export const DESCRIPTION = {
  [JETPACK_ONBOARDING_STEPS.STEP_1_GAMES]: tt(
    "jetpack_onboarding_step_2_description"
  ),
  [JETPACK_ONBOARDING_STEPS.STEP_2_CTAs]: "",
  [JETPACK_ONBOARDING_STEPS.STEP_3_GIFTS]: tt(
    "jetpack_onboarding_step_8_description"
  )
};

export const BACKGROUND = {
  [JETPACK_ONBOARDING_STEPS.STEP_0_INFO]: `background/bg_01.png`,
  [JETPACK_ONBOARDING_STEPS.STEP_1_GAMES]: `background/bg_02.png`,
  [JETPACK_ONBOARDING_STEPS.STEP_2_CTAs]: `background/bg_03.png`,
  [JETPACK_ONBOARDING_STEPS.STEP_3_GIFTS]: `background/bg_04.png`,
  [JETPACK_ONBOARDING_STEPS.STEP_4_LAST_STEP]: `background/bg_04.png`,
  [JETPACK_ONBOARDING_STEPS.STEP_5_ROCKET_ANIMATION]: `background/bg_04.png`
};

export const POSA_PLACEHOLDER_IMAGE: Partial<Record<POSA_FORMAT, string>> = {
  flyer_a5: `/img/chevalet-a5-2.jpg`,
  flyer_a6: `/img/chevalet-a6-2.jpg`,

  chevalet_a5: "/img/chevalet_a6.webp",
  chevalet_a6: "/img/chevalet_a6.webp",

  stickers10x10: `/img/sticker.png`,
  stickers_dome: `/img/dome.png`,

  a_long: `/img/a_long.jpg`,
  businesscardsstandard: `/img/business_card.png`,

  kakemono: "/img/kakemono.png",

  poster_a2: "/img/poster_a2.jpg",
  poster_a3: "/img/poster_a3.jpg",
  poster_a4: "/img/poster_a4.jpg"
};
